import { createApp } from 'vue'
import App from './App.vue'
import Axios from "axios"
import  '@/styles/custom.css';
import { registerPlugins } from '@/plugins'
import Vue3Toastify from 'vue3-toastify';
import  store from '@/store/index';
import 'vuetify/styles' // Vuetify styles
import '@mdi/font/css/materialdesignicons.css'
import 'vue3-toastify/dist/index.css'
import { Ckeditor } from '@ckeditor/ckeditor5-vue';
import VueApexCharts from "vue3-apexcharts";
import { formatDateView, formatDateDash, formatDateAll, getCompanyInfo, number_format } from '@/plugins/helpers'

const app = createApp(App)

app.use(Ckeditor);
app.use(VueApexCharts);

registerPlugins(app);
app.use(store)

app.use(
  Vue3Toastify,
  {
    autoClose: 3000,
    // multiple: false,
    style: {
      opacity: '0.9',
      userSelect: 'initial',
    },
    transition: 'slide',
    position:'top-right'
  } 
);
// Global helper functions
app.config.globalProperties.$formatDateView = formatDateView
app.config.globalProperties.$formatDateDash = formatDateDash
app.config.globalProperties.$formatDateAll = formatDateAll
app.config.globalProperties.$getCompanyInfo = getCompanyInfo
app.config.globalProperties.$number_format = number_format

app.mount('#app')

Axios.interceptors.request.use(
  config => {
    let token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status == "401") {
      localStorage.clear();
      location.reload();
    }
    return Promise.reject(error);
  }
);
